export interface DetailRouteSearch {
  id?: string | number;
  account?: string;
  salesOrg?: string;
}

export function parseDetailRouteSearch(search: Record<string, unknown>): DetailRouteSearch {
  return {
    id: parseRouteIdentifier(search.id),
    account: typeof search.account === "string" ? search.account : undefined,
    salesOrg: typeof search.salesOrg === "string" ? search.salesOrg : undefined,
  };
}

export function toPageDataDetailSearch(search: DetailRouteSearch) {
  return {
    id: search.id === undefined ? undefined : String(search.id),
    account: search.account,
    salesOrg: search.salesOrg,
  };
}

function parseRouteIdentifier(value: unknown): string | number | undefined {
  if (typeof value === "string") {
    return value;
  }
  return typeof value === "number" && Number.isFinite(value) ? value : undefined;
}
